// extracted by mini-css-extract-plugin
module.exports = {"logs__form":"Logs_logs__form__2mx7O"};